//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryOrder, orderPay } from "../../model/trader/queryServer";
import { store } from "../../observable/store";
import { wxAuth, wxChat } from "../../model/api/wxconfigServer.js";
import { toApp } from "../../utils/appBridge";
import  mixinPay  from "@/utils/mixin/mixinPay.js";
import bridgeApi from "sy-bridge";
import Txrweb from "@/utils/mixin/mixinTxrweb";

export default {
  name: "pay",
  mixins: [Txrweb,mixinPay],
  data() {
    return {
      payFlag: "3",
      MWEBFlag: true,
      // uuid: null,
      // outTrade: null,
      nameOd: null,
      amount: null,
      wxChatFlag: false,
      repeat: true,
      openidFlag: false, // 微信环境  openid 不存在 则显示
      app_success_url:'/paySuccess'
    };
  },
  computed: {
    wxAppid() {
      return store.wxAppid;
    },
    wxCode() {
      return store.wxCode;
    },
    refid() {
      return store.refid;
    },
    version() {
      return store.version;
    },
    openid() {
      return store.openid;
    },
    templateFlag() {
      return store.refid.product_id;
    },
    paySuccessSate(){
      return this.$route.query.paySuccessSate
    }
  },
  created() {
    // 页面id 页面带的附加信息可空
    // let uuid = this.$route.query.uuid;
    // if (Array.isArray(uuid)) { 
    //   this.uuid = uuid[0];
    // } else {
    //   this.uuid = uuid;
    // }
    // this.outTrade = this.$route.query.outTrade;
    let typeflag = this.templateFlag == "coupon" ? "coupon" : "insurance";
    queryOrder({ type: typeflag, outTrade: this.outTrade }).then((data) => {
      //console.log('66',data)
      this.nameOd = data.goods[0].name;
      this.amount = data.goods[0].amount / 100;
      if (data.repeat) {
        this.repeat = false;
        this.$toast(data.message);
      }
    });

    if(this.paySuccessSate == "activation"){
      this.app_success_url = '/happySuccess'
    }
  },
  mounted() {
    if (this.CHANNAL_ID == "APP") {
      if (this.version && this.version < "7.32.1") {
        this.$alert({
          msg:'请升级新氧APP至最新版本后支付',
          title:'版本过低',
        })
      }
    }
    if (this.CHANNAL_ID == "JSAPI") {
      this.wxChatFlag = true;
    }
    if (this.CHANNAL_ID == "MWEB") {
      this.MWEBFlag = false;
      // this.payFlag = '1';
    }
    // 埋点
    this.STATISTICS_CONFIG.insur_cashier_page()
    if(this.templateFlag != 'coupon'){ //coupon为卡券购买 不需要录入视频
      this.payTX();
    }
  },
  methods: {
    orderPrice() {
      this.$loading.show()

      let _this = this;
      this.STATISTICS_CONFIG.insur_cashier_pay_click()
      //app  system 1  其余时候 0
      // is_weixin 微信公众号 1 其余 0
      // if(!this.repeat){
      //     return;
      // }
      // console.log('213123',test)
      let wxFlag, systemFlag;
      if (this.CHANNAL_ID == "JSAPI") {
        wxFlag = "1";
      } else {
        wxFlag = "0";
      }
      // 0 - web，1 - ios，2 - android，3 - H5/M，4 - 公众号,
      if (this.CHANNAL_ID == "APP") {
        if (this.IOS_AND == "IOS") {
          systemFlag = "1";
        }
        if (this.IOS_AND == "Android") {
          systemFlag = "2";
        }
      }
      if (this.CHANNAL_ID == "MWEB") {
        systemFlag = "3";
      }
      if (this.CHANNAL_ID == "JSAPI") {
        systemFlag = "4";
      }
      // systemFlag = '1'
      let parme = {
        outTrade: this.outTrade,
        data: {
          pay_type: this.payFlag,
          code: this.wxCode,
          //    system:'0',  //1是app
          //    is_weixin: "1",
          system: systemFlag, //1是app
          is_weixin: wxFlag,
          app_id:bridgeApi.appInfo? bridgeApi.appInfo.app_id : '', // appid
          
          // url: `${window.location.origin}/paySuccess?flag=postdisable&uuid=${this.uuid}&templateFlag=${this.templateFlag}&outTrade=${this.outTrade}`,
        },
      };
      orderPay(parme)
        .then((data) => {
          this.$loading.hide()
          if(data.entrust_info){//签约 
              this.paySign(data)
          }else{ //支付
              this.topayTX(data,"3")
          }
        })
        .catch((err) => {
          // 重复购买
          this.$toast(err.message);
          if (err.message != "重复购买" && this.CHANNAL_ID == "JSAPI") {
            this.STATISTICS("click", "sybao_wx_pay_err_click");
          }
        }).finally(()=>{
              this.$loading.hide()
          });
    },
    quota() {
      this.$router.push({
        path: "/quota",
      });
    },
    selectBtn(e) {
      //console.log(e)
      this.payFlag = e;
    },
  },
};
